module.exports = __webpack_public_path__ + "img/Sun.3a51510b.svg";